import { AssetsAvailable } from './assets-available.interface';

export interface AssetsAvailablePagination {
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  offset: number;
  pageNumber: number;
  pageSize: number;
  paged: boolean;
  unpaged: boolean;
}

export interface AssetsAvailableData {
  content: AssetsAvailable[];
  pageable: AssetsAvailablePagination;
  totalElements: number;
  totalPages: number;
  last: boolean;
  size: number;
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  numberOfElements: number;
  first: boolean;
  empty: boolean;
}

export interface AssetsAvailableResponse {
  timestamp: string;
  status: string;
  data: AssetsAvailableData;
}

export function createEmptyAssetsAvailable(): AssetsAvailable[] {
  return [
    {
      release: {
        id: 0,
        hash: '',
        title: '',
        titleVersion: '',
        artistNames: '',
        hasReleased: false,
        upc: '',
        releaseDate: '',
        releaseType: '',
        label: {
          id: '',
          imageId: '',
          name: '',
          description: '',
        },
        tracks: [],
        eligibleForSplit: true,
        checked: false,
        childrenOpened: false,
      },
      track: {
        id: 0,
        hash: '',
        title: '',
        titleVersion: '',
        artistNames: '',
        eligibleForSplit: {
          eligible: false,
          reason: '',
          ruleNotEligible: {
            countryList: [],
            dspList: [],
          },
        },
        isrc: '',
        label: {
          id: '',
          imageId: '',
          name: '',
          description: '',
        },
        checked: false,
      },
    },
  ];
}
